import SEOLink from '@Components/Listings/SEOLink';
import { BaseTypography } from '@Components/MuiWrappers/Typography';
import { useState } from 'react';
import translator from '@Components/Utilities/Translator';



const SEOLinkWindow = (props) => {
    const [showAllCities, setShowAllCities] = useState(false);


    const toggleShowAllCities = () => {
        setShowAllCities(!showAllCities)
    }

    const renderCityLinks = () => {
        const allLinks = props.InternalLinkColumns
            ? props.InternalLinkColumns.flatMap(col => col.InternalLinks)
            : [];

        return (
            <div className="new-city-links-container">
                <div className='city-links-grid'>
                    {allLinks.map((link, index) =>
                        <SEOLink key={link.ReactKey} IsHostedSite={props.IsHostedSite} HideLink={!showAllCities && index > 9} {...link} />
                    )}
                </div>
                {allLinks.length > 10 &&
                    <button className="ts-button" onClick={() => toggleShowAllCities()}>
                        {showAllCities ? translator.translate("sandhills.tradesites.mvc.showfewercities") : translator.translate("sandhills.tradesites.mvc.seeallcities")}
                    </button>
                }
            </div>
        );
    };

    return (
        <div className='linking-container'>
            {props.IsSearchBySpecs ?
                <h2>{props.InternalLinkGroup.DisplayText}</h2> :
                props.IsHostedSite ?
                    <BaseTypography className='' component='h4'>{props.InternalLinkGroup.DisplayText}</BaseTypography> :
                    <span className='internal-linking-top'>{props.InternalLinkGroup.DisplayText}</span>}
            < br />
            {props.InternalLinkGroup.Name == "City" && props.ShowCityLinks ?
                renderCityLinks()
                :
                <div className='cf'>
                    {props.InternalLinkColumns && props.InternalLinkColumns.map(linkColumn =>
                        <div key={linkColumn.ReactKey} className='column3 left'>
                            <ul>
                                {linkColumn.InternalLinks.map(link =>
                                    <SEOLink key={link.ReactKey} IsHostedSite={props.IsHostedSite} {...link} />)}
                            </ul>
                        </div>)}
                </div>}
        </div>
    );
};

export default SEOLinkWindow;